import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {MAX_COMMENT_LENGTH, MAX_QUESTION_LENGTH, MIN_QUESTION_LENGTH} from './constant';

/**
 * @deprecated Use yesNoQuestionV2Validator instead.
 */
export const yesNoQuestionValidator = z.object({
    type: z.literal(ELEMENT.YES_NO_QUESTION),
    question: z.string().min(1, `question;min;${MIN_QUESTION_LENGTH}`).max(MAX_QUESTION_LENGTH, `question;max;${MAX_QUESTION_LENGTH}`),
    comment: z.object({
        yes: z.string().max(MAX_COMMENT_LENGTH, `comment;max;${MAX_COMMENT_LENGTH}`),
        no: z.string().max(MAX_COMMENT_LENGTH, `comment;max;${MAX_COMMENT_LENGTH}`),
    }),
});
